import React, { useEffect, useState } from "react";
import SelectReact from "react-select";
import { ApiResponse } from "Types/OSM/Response";

export type JenisOption = {
  value: number;
  label: string;
  name?: string;
};

interface JenisSelectProps {
  value: JenisOption | null;
  onChange: (value: JenisOption | null) => void;
  placeholder?: string;
  initialValueId?: number | null;
}

const JenisSelect = ({
  value,
  onChange,
  placeholder = "Pilih jenis surat...",
  initialValueId,
}: JenisSelectProps) => {
  const [options, setOptions] = useState<JenisOption[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchJenis = async () => {
      try {
        setLoading(true);
        const res = await fetch("/api/doServices", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            method: "GET",
            endpoint: `office/jenis?page=1&limit=1000`,
            isForm: false,
            isImage: false,
          }),
        });

        if (!res.ok) {
          setLoading(false);
          return;
        }

        const result = (await res.json()) as ApiResponse;
        if (result.http_code !== 200 || !Array.isArray(result.data)) {
          setLoading(false);
          return;
        }

        const opts: JenisOption[] = result.data.map((item: any) => ({
          value: item.id,
          label: item.name ?? "",
          name: item.name,
        }));

        setOptions(opts);

        // Auto-select berdasarkan initialValueId
        if (initialValueId && !value) {
          const foundOption = opts.find(opt => opt.value === initialValueId);
          if (foundOption) {
            onChange(foundOption);
          }
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetch jenis:", err);
        setLoading(false);
      }
    };

    fetchJenis();
  }, [initialValueId, onChange, value]);

  return (
    <SelectReact
      isMulti={false}
      isLoading={loading}
      options={options}
      value={value}
      onChange={(val) => onChange(val as JenisOption | null)}
      placeholder={placeholder}
      isClearable
      classNamePrefix="react-select"
    />
  );
};

export default JenisSelect;
